import { Header } from '@components/Header';
import { routes } from '@routes';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const tracks = [
  {
    title: 'AutoScript Desktop',
    description:
      'With a look and feel of Word but packed with editing features and synchronized audio commonly found in CAT software, most users will find our free editing tool dramatically accelerates their speed and efficiency compared to traditional word processing tools.',
    folder: 'ASD',
  },
  {
    title: 'Word or WordPerfect',
    description:
      "Don't want to change just yet? You can still get major productivity gains with AutoScript by turning audio into rough drafts through AutoScript Web, uploading the RTF file into your word processor and listening to the audio in a separate audio player like ExpressScribe.",
    folder: 'Word-Word Perfect',
  },
  {
    title: 'CAT Software',
    description:
      'AutoScript allows you to produce synchronized rough transcripts and easily import the transcript text and audio files directly into Case CATalyst, Eclipse, ProCAT and other CAT platforms. You will be amazed at how much faster you can be!',
    folder: 'CAT Export',
  },
] as const;

export const TrainingEditorProoferPage = () => (
  <>
    <Helmet>
      <title>Editor-Proofer Training - AutoScript</title>
    </Helmet>
    <Header title="Editor-Proofer Training" backRoute={routes.training.make()} />

    <main className="px-4 md:px-[30px] pt-2 pb-[70px] max-w-[1100px]">
      <h2 className="text-xl font-semibold text-[var(--color-text)] m-0">It&apos;s your choice</h2>
      <p className="mt-3 mb-6 text-sm leading-[150%] text-[var(--color-text-muted)] max-w-[720px]">
        You can choose to follow one or all of the interactive Editor/Proofer tutorials based on your preferred editing
        methodology. Each course is designed to take 20 minutes or less of your time.
      </p>

      <div className="grid gap-4 md:grid-cols-3">
        {tracks.map((track) => (
          <div
            key={track.folder}
            className="flex flex-col border border-[var(--color-border)] rounded-[8px] bg-[var(--color-surface)] p-5"
          >
            <h3 className="text-base font-semibold text-[var(--color-text)] m-0">{track.title}</h3>
            <p className="mt-3 mb-5 text-sm leading-[150%] text-[var(--color-text-muted)] flex-1">
              {track.description}
            </p>
            <Link to={routes.trainingFolder.make('Editor-Proofer', track.folder)} className="btn w-full justify-center">
              Let&apos;s Get Started
            </Link>
          </div>
        ))}
      </div>
    </main>
  </>
);
